/** Compact number formatting for counters: 1_240 -> "1.2k". */
export function formatCount(value: number): string {
  if (!Number.isFinite(value) || value <= 0) return "0"
  if (value < 1000) return String(Math.round(value))
  if (value < 10_000) return `${(value / 1000).toFixed(1).replace(/\.0$/, "")}k`
  if (value < 1_000_000) return `${Math.round(value / 1000)}k`
  return `${(value / 1_000_000).toFixed(1).replace(/\.0$/, "")}m`
}

export function shortenMiddle(value: string, head = 8, tail = 6): string {
  if (value.length <= head + tail + 1) return value
  return `${value.slice(0, head)}…${value.slice(-tail)}`
}

/** Strips control characters and collapses whitespace for single line labels. */
export function toSingleLine(value: string, max = 200): string {
  return value
    .replace(/[\u0000-\u001f\u007f]/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .slice(0, max)
}

export function isProbablyUrl(value: string): boolean {
  return /^https?:\/\/\S+$/i.test(value.trim())
}

/** Escapes text for safe use inside an HTML attribute or CSS selector value. */
export function cssId(value: string): string {
  return value.replace(/[^a-zA-Z0-9_-]/g, "_")
}
